import { useTranslation } from 'react-i18next';

import { StyledText } from '@selfserve/react-ui';

import {
  StyledLoader,
  StyledPriceContainer,
  StyledPricePair,
} from '../feature/summary';

interface Props {
  isLoading: boolean;
  withLine?: boolean;
  hideSecondaryPart?: boolean;
  name: string;
  price: string;
}

export const SummaryPriceContainer = ({
  hideSecondaryPart,
  withLine,
  isLoading,
  price,
  name,
}: Props) => {
  const { t } = useTranslation();
  return (
    <StyledPriceContainer withLine={withLine}>
      <StyledPricePair>
        <StyledText as="div" className="summary-item-name" bold isSmall>
          {name}
        </StyledText>
        <StyledText as="div" bold isSmall>
          {isLoading ? <StyledLoader /> : `$${price}`}
        </StyledText>
      </StyledPricePair>
      {!hideSecondaryPart && (
        <StyledPricePair secondary>
          <StyledText as="div" className="summary-item-description">
            {t('common.before-taxes')}
          </StyledText>
        </StyledPricePair>
      )}
    </StyledPriceContainer>
  );
};
